module.exports = function () {
  $('input[name="choixprojet"]').change(function(e) {
    if($('#magexiste').is(':checked')) {
      $("#ifMagExist").show();
      $("#ifMagExist input.isRequired").attr("required",true)
      $("#ifProjet").hide();
      $("#ifProjet input.isRequired").attr("required",false)
    }else{
      $("#ifMagExist").hide();
      $("#ifMagExist input.isRequired").attr("required",false)
      $("#ifProjet").show();
      $("#ifProjet input.isRequired").attr("required",true)

    }
  });

  return true;
};



//////////////////
// WEBPACK FOOTER
// ./app/pages/index/js/adhesion.js
// module id = 11
// module chunks = 0